import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Dialog, FlatButton } from 'material-ui'
import styles from './styles.css'

const attributionsObj = {
  google: 'Google',
  facebook: 'Facebook',
  yelp: 'Yelp',
  doctor_referral: 'Doctor Referral',
  patient_referral: 'Patient Referral',
  other: 'Other',
}

class Attribution extends Component {
  state = { dialogOpen: false }

  toggleDialog = (e) => {
    if (this.props.otherAttribution) {
      e.stopPropagation()
      this.setState({ dialogOpen: !this.state.dialogOpen })
    }
  }

  createSvgString = attr =>
    `/images/${attributionsObj[attr] ? attr : 'patient_referral'}.svg`

  render() {
    const { attribution, otherAttribution } = this.props

    const attributionStyles = cx(styles.attribution, {
      [styles.attributionHasOther]: otherAttribution,
    })

    return (
      <div className={attributionStyles}>
        <div className={styles.attributionIconCtnr} onClick={this.toggleDialog}>
          <img
            className={styles.attributionIcon}
            src={this.createSvgString(attribution)}
            alt={attributionsObj[attribution] || attribution}
          />
        </div>
        <div
          className={styles.attributionHoverTextCtnr}
          onClick={this.toggleDialog}
        >
          <span className={styles.attributionHoverText}>
            {attributionsObj[attribution] || attribution}
          </span>
        </div>
        {otherAttribution && (
          <Dialog
            open={this.state.dialogOpen}
            onRequestClose={this.toggleDialog}
            maxWidth="sm"
            style={{ zIndex: '9999' }}
          >
            <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
              Referred By:
            </div>
            <div style={{ margin: '10px auto' }}>{otherAttribution}</div>
            <FlatButton label="Close" onClick={this.toggleDialog} secondary />
          </Dialog>
        )}
      </div>
    )
  }
}

Attribution.propTypes = {
  attribution: PropTypes.string.isRequired,
  otherAttribution: PropTypes.string,
}

export default Attribution



// WEBPACK FOOTER //
// ./src/components/OnlineScheduling/BookingPatients/Attribution.js